<template>
    <div class="commonNav">
        <div class="nav-container">
            <div class="nav-left">
                <div class="logo">
                    <img @click="toHref('/')" v-if="platInfo.logo" :src="commenUrl + platInfo.logo" alt="" />
                </div>
            </div>
            <div class="nav-right">
                <img class="sousuo-icon" @click="toHref('oneStopSearchNews')" src="../assets/images/index/sousuo.png"
                    alt="">
                <img class="sousuo-user" @click="getUser" src="../assets/images/index/user.png"
                alt="">
                <div class="more-icon" v-if="!isNavOpen" @click="toggleNav">
                    <img src="../assets/images/index/more.png" alt="">
                </div>
                <el-icon class="close-icon" size="30" @click="toggleNav" v-else>
                    <Close />
                </el-icon>
            </div>
        </div>
        <div class="nav-overlay" :class="{ active: isNavOpen }">
            <div class="nav-panel" :class="{ active: isNavOpen }">
                <div class="nav-content">
                    <!-- 左侧一级菜单 -->
                    <ul class="nav-level-1">
                        <li v-for="(level1, index1) in navData" :key="index1">
                            <div class="nav-item" :class="{ active: activeLevel1 === index1 }"
                                @click="selectLevel1(index1, level1)">
                                <span class="nav-icon"></span>
                                {{ level1.name }}
                            </div>
                        </li>
                    </ul>
                    <!-- 右侧二级菜单 -->
                    <div class="nav-level-2-container">
                        <div v-if="activeLevel1 !== null">
                            <div class="nav-level-2-title" v-if="navData[activeLevel1]?.depict">
                                {{ navData[activeLevel1].depict }}
                                <el-icon v-if="navData[activeLevel1].depictLink">
                                    <ArrowRight />
                                </el-icon>
                            </div>
                            <ul class="nav-level-2">
                                <li v-for="(level2, index2) in navData[activeLevel1].children" :key="index2">
                                    <div class="nav-item" :class="{ active: activeLevel2 === index2 }"
                                        @click="toggleLevel2(index2,level2)">
                                        {{ level2.name }}
                                        <el-icon class="nav-arrow" :class="{ active: activeLevel2 === index2 }"
                                            v-if="level2.children?.length">
                                            <ArrowDown />
                                        </el-icon>
                                    </div>
                                    <!-- 三级菜单 -->
                                    <ul class="nav-level-3" :class="{ active: activeLevel2 === index2 }">
                                        <li v-for="(level3, index3) in level2.children" :key="index3">
                                            <a class="nav-item" href="#"
                                                @click="toHref(level3.outsideLink, level3.outsideLinkTarget)">
                                                {{ level3.name }}
                                            </a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
            v-model="dialogVisible"
            title="提示"
            width="80%"
            align-center
        >
            <span>是否要退出</span>
            <template #footer>
            <div class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" class="saveBtn" @click="logout">
                确认
                </el-button>
            </div>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { getCurrentInstance, ref, watch, computed, onMounted, nextTick } from "vue";
import { ElMessage } from 'element-plus'
import { Close, ArrowRight, ArrowDown } from '@element-plus/icons-vue'
import { useRouter } from 'vue-router'
const router = useRouter();
const { proxy } = getCurrentInstance();
const props = defineProps({
    platInfo: {
        type: Object,
        default: {}
    }
})
const updateTheme = () => {
    document.documentElement.style.setProperty('--el-color-primary', props.themeColor);
}
updateTheme()
const isNavOpen = ref(false);
const navData = ref([
    {
        name: '',
        children: []
    }
]);

// 获取导航列表
const getNavList = () => {
    proxy.$request({
        url: "PROTAL_N_INDUSTRYMENU_FINDTREELIST",
        method: "post",
        data: { "portalType": proxy.getConfig().portalType }
    }).then((res) => {
        if (res.data.code == "000") {
            console.log(res.data.result);
            navData.value = res.data.result;
        }
    }).catch((err) => {
        console.log(err);
    });
}
getNavList()
// 响应式数据
const activeLevel1 = ref(0);
const activeLevel2 = ref(null);
const currentPage = ref('首页');

// 方法
const toggleNav = () => {
    isNavOpen.value = !isNavOpen.value;
    // 关闭导航时重置菜单状态
    if (!isNavOpen.value) {
        activeLevel1.value = 0;
        activeLevel2.value = null;
    }
};

const closeNav = () => {
    isNavOpen.value = false;
    activeLevel1.value = 0;
    activeLevel2.value = null;
};
const selectLevel1 = (index, data) => {
    console.log(data)
    if (data.children) {
        activeLevel1.value = index;
        activeLevel2.value = null;
    } else {
        toHref(data.outsideLink,data.outsideLinkTarget)
    }

};

const toggleLevel2 = (index,data) => {
    if(data.children&&data.children.length>0){
        if (activeLevel2.value === index) {
            activeLevel2.value = null;
        } else {
            activeLevel2.value = index;
        }
    }else{
        toHref(data.outsideLink,data.outsideLinkTarget)
    }
    
};
const navigateTo = (link) => {
    currentPage.value = link;
    closeNav();
    // router.push(link);
};
// 读取有效期内的用户名
  function getExpiringUsername(key) {
    const storedData = localStorage.getItem(key);
    
    if (!storedData) return null;
    
    const { value, expiry } = JSON.parse(storedData);
    const now = Date.now();
    
    // 检查是否过期
    if (now > expiry) {
      localStorage.removeItem(key); // 过期则删除
      return null;
    }
    
    return value; // 返回有效用户名
  }
  const getUrlParams = (url)=> {
      let params = {};
      // 处理URL，提取问号后的参数部分
      const urlStr = url || window.location.href;
      const queryString = urlStr.split('?')[1];
      
      if (!queryString) return params; // 没有参数则返回空对象
      
      // 分割参数（支持&和;分隔）
      const parts = queryString.split(/[&;]/g);
      
      for (const part of parts) {
        // 分割键值对（支持=和:分隔）
        const [key, value] = part.split(/[=:]/);
        if (key) {
          // 解码特殊字符（如中文、空格等）
          params[decodeURIComponent(key)] = decodeURIComponent(value || '');
        }
      }
      
      return params;
    }
// 判断是否为完整URL
const isFullUrl = (url) => {
    return /^https?:\/\//.test(url);
};
const toHref = (url, type) => {
    if (!url) {
        return;
    }
    if (getUrlParams(url).loginType == 'yunying' && !getExpiringUsername("sznc_WebsiteUsername_yy")) {
        if (type === '_blank' || type == '1') {
            // 新标签页打开
            const href = router.resolve({
                path: '/loginYy',
                query: { toPath: btoa(url) }
            }).href;
            proxy.tool.openWindow(href);
        } else {
            router.push({
                path: '/loginYy',
                query: {
                    toPath: btoa(url)
                }
            });
        }

        return;
    }
    if (type === '_blank' || type == '1') {
        // 新标签页打开
        proxy.tool.openWindow(url);
    } else if (isFullUrl(url)) {
        // 完整URL，使用页面跳转
        window.location.href = url;
    } else {
        // 相对路径，使用路由跳转
        router.push(url);
    }
    closeNav()
};
// 退出
const getUser = ()=>{
    if(proxy.getCookie('userInfoB2B')){
        dialogVisible.value = true
    }else{
        toHref('login')
    }
}
const dialogVisible = ref(false);
const logout = () => {
  proxy.$request({
    url: "SECURITY_W_LOGOUT",
    method: "post",
  }).then((res) => {
    if (res.data.code == "000") {
      localStorage.setItem("userInfoB2B", "");
      dialogVisible.value = false
      ElMessage({
        type: 'success',
        message: `退出成功`,
      })
    }
  }).catch((err) => {
    console.log(err);
    if(err.status=='401'){
        localStorage.setItem("userInfoB2B", "");
        dialogVisible.value = false
        toHref('login')
    }
  });
}
onMounted(() => {

});
</script>

<style lang="less" scoped>
.commonNav {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    height: 44px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
    background: #fff;

    .nav-container {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .nav-left {
            display: flex;
            align-items: center;

            .logo {
                height: 60px;
                display: flex;
                align-items: center;

                img {
                    width: 200px;
                    height: auto;
                }
            }
        }

        .nav-right {
            display: flex;
            align-items: center;

            .sousuo-icon {
                width: 16px;
                height: 17px;
                margin-right: 12px;
            }
            .sousuo-user{
                width: 20px;
                height: 20px;
                margin-right: 12px;
            }
            .more-icon {
                width: 24px;
                height: 24px;
                display: flex;
                align-items: center;

                img {
                    width: 16px;
                    height: 13px;
                }
            }

            .close-icon {
                width: 24px;
                height: 24px;
                color: #000;
            }

            .nav-item {
                color: #000;

                &:hover {
                    color: #000;
                }
            }
        }
    }

    .nav-overlay {
        position: fixed;
        top: 44px;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(225, 225, 225, 0.9);
        z-index: 99;
        opacity: 0;
        visibility: hidden;
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.5s ease-out;
        font-size: 12px;
        border-top: 2px solid #DCDEDD;
        ;

        &.active {
            opacity: 1;
            visibility: visible;
            max-height: 100%;
        }

        .nav-panel {
            width: 100%;
            height: 100%;
            background-color: #fff;
            transition: right 0.3s ease;
            overflow-y: auto;
            display: flex;
            flex-direction: column;
        }

        .nav-content {
            flex: 1;
            display: flex;
            overflow: hidden;

            /* 一级菜单 */
            .nav-level-1 {
                width: 35%;
                background-color: #F4F4F4;
                overflow-y: auto;

                li {
                    list-style: none;

                    .nav-item {
                        display: block;
                        padding: 15px 12px;
                        font-weight: 500;
                        cursor: pointer;
                        transition: background-color 0.2s;
                        // border-left: 3px solid transparent;
                        color: #131415;

                        .nav-icon {
                            display: inline-block;
                            margin-left: -12px;
                            width: 3px;
                            height: 12px;
                            background-color: transparent;
                            margin-right: 11px;
                        }

                        &:hover {
                            background-color: #e9ecef;
                        }

                        &.active {
                            background-color: white;
                            border-left-color: #1663FF;
                            color: #1663FF;
                            font-weight: 600;

                            .nav-icon {
                                background-color: #1663FF;
                            }
                        }
                    }
                }
            }

            /* 二、三级菜单 */
            .nav-level-2-container {
                width: 65%;
                overflow-y: auto;
                padding: 15px;

                .nav-level-2-title {
                    margin-bottom: 15px;
                    padding-bottom: 8px;
                    line-height: 22px;
                    color: #8D8D8D;
                    font-weight: 500;

                    .el-icon {
                        vertical-align: middle;
                    }
                }

                /* 二级菜单 */
                .nav-level-2 {
                    list-style: none;

                    li {
                        .nav-item {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            padding: 12px 0;
                            color: #131415;
                            border-bottom: 1px solid #E3E3E3;
                            cursor: pointer;
                            font-weight: 500;
                            transition: all 0.2s;

                            &.active {
                                color: #1663FF;
                            }
                        }
                    }
                }

                /* 三级菜单 */
                .nav-level-3 {
                    list-style: none;
                    max-height: 0;
                    overflow: hidden;
                    transition: max-height 0.3s ease;
                    margin-top: 5px;
                    border-radius: 6px;

                    &.active {
                        max-height: 300px;
                    }

                    &:hover {
                        color: #1663FF;
                    }

                    li {
                        margin: 0;

                        .nav-item {
                            display: block;
                            padding: 10px 15px;
                            padding-left: 35px;
                            cursor: pointer;
                            transition: background-color 0.2s;
                            color: #131415;
                            border-bottom: none;
                            font-weight: 400;
                        }
                    }
                }
            }
        }
    }
    .saveBtn{
        background-color: #409eff;
    }
    .dialog-footer{
        justify-content: end;
    }
}
</style>